import { render, staticRenderFns } from "./usersView.vue?vue&type=template&id=aada1d78"
import script from "./usersView.vue?vue&type=script&lang=js"
export * from "./usersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports